// extracted by mini-css-extract-plugin
export default {"selection":"select__selection","multipleSelection":"select__multipleSelection","treeSelection":"select__treeSelection"};